import { Box, Divider, Typography } from "@mui/material";

const ConversationSidebar = ({ detail }) => {
  if (!detail) return null;

  return (
    <Box sx={{ width: "30%", borderRight: 1, borderColor: "divider", p: 3, bgcolor: "background.default", display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="caption" color="textSecondary" display="block">ART</Typography>
        <Typography variant="body2" fontWeight="bold">{detail.nombreArt || "-"}</Typography>
      </Box>

      <Box>
        <Typography variant="caption" color="textSecondary" display="block">Título</Typography>
        <Typography variant="body2" fontWeight="bold">{detail.titulo}</Typography>
      </Box>

      <Box>
        <Typography variant="caption" color="textSecondary" display="block">Tipo / Subtipo</Typography>
        <Typography variant="body2" fontWeight="bold">{detail.tipo} / {detail.subtipo}</Typography>
      </Box>

      <Box>
        <Typography variant="caption" color="textSecondary" display="block">Siniestro</Typography>
        <Typography variant="body2" fontWeight="bold">{detail.nroReferencia || "-"}</Typography>
      </Box>

      <Box>
        <Typography variant="caption" color="textSecondary" display="block">Trabajador</Typography>
        <Typography variant="body2" fontWeight="bold">{detail.nombreTrabajador || "-"}</Typography>
      </Box>

      <Box>
        <Typography variant="caption" color="textSecondary" display="block">Empleador</Typography>
        <Typography variant="body2" fontWeight="bold">{detail.nombreEmpleador || "-"}</Typography>
      </Box>

      <Divider sx={{ my: 1 }} />

      <Box>
        <Typography variant="caption" color="textSecondary" display="block">Creada el</Typography>
        <Typography variant="body2" fontWeight="bold">{detail.fechaCreacion}</Typography>
      </Box>

      <Box>
        <Typography variant="caption" color="textSecondary" display="block">Último mensaje</Typography>
        <Typography variant="body2" fontWeight="bold">{detail.fechaHoraUltimoMensaje}</Typography>
      </Box>
    </Box>
  );
};

export default ConversationSidebar;
